import { apiRequest } from './index';

export const fetchPagIbigRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/pag-ibigs/' + id, {}, success, failure);
}

export const fetchPagIbigsRequest = ( selectedDate, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest(`/pag-ibigs?selectedDate=${selectedDate}`, {}, success, failure);
}

export const createPagIbigRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pag-ibigs',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const createPagIbigGroupRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pag-ibigs/group',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const editPagIbigRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pag-ibigs/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
}

export const deletePagIbigRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pag-ibigs/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
}

export const getEffectiveDateList = ( success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pag-ibigs/effective-date/list',
        { method: 'GET' },
        success,
        failure
    )
}